<template>
    <div class="card-page container" :style="{ 'min-height': bodyHeight + 'px' }">
        <navBar :title="title" @onClickLeft="handleBack">
        </navBar>
        <div class="container_pad">
            <img class="title img-h-1" src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/wdn-h5/entityCard/employment_power1_1.png" alt="">
            <img class="title img-h-2" src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/wdn-h5/entityCard/employment_power2_new.jpg" alt="">
            <div class="ercode_box">
                <img class="title" src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/wdn-h5/entityCard/employment_power3_new.png" alt="">
                <img class="ercode" src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/wdn-h5/entityCard/ercode.png" alt="">
            </div>
            <a class="recharge_btn" v-if="!iswx"
                href="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/wdn-h5/entityCard/ercode.png?response-content-type=application/octet-stream" download>保存二维码</a>
            <div class="recharge_btn" v-if="iswx">长按图片保存二维码</div>
        </div>

    </div>
</template>


<script>
import navBar from '../components/navBar.vue';

export default {
    components: {
        navBar,
    },
    data() {
        return {
            iswx: false,
            actionData: {},
            title:this.$route.meta.title
            
        }
    },
    created() {
        this.iswx = this.WeiXin();
        this.bodyHeight = window.screen.height;
    },
    methods: {
        handleBack() {
            this.$router.go(-1);
        },
        WeiXin() {
            // 判断是否是微信内置浏览器
            let isWeiXin = () => {
                return (
                    navigator.userAgent
                        .toLowerCase()
                        .indexOf('micromessenger') !== -1
                )
            }
            if (isWeiXin()) {
                return true
            } else {
                return false
            }
        },
        show(item) {
            this.actionData = item;
        },
    },
}
</script>

<style lang="less" scoped>
.container {
    width: 100%;
    height: 100%;
    background-image: url('https://wd-appdownload.oss-cn-beijing.aliyuncs.com/wdn-h5/entityCard/employment_power_bgc.png');
    background-size: 100% 100%;
    
}
.container_pad {
    padding: 58px 35px;
    .img-h-1 {
        height: 211px;
    }
    .img-h-2 {
        height: 721px;
    }
}

.title {
    width: 100%;
    display: block;
}
.ercode_box {
    position: relative;
    height: 290px;
    .ercode {
        width: 186px;
        height: 186px;
        position: absolute;
        top: 50%;
        right: 55px;
        margin-top: -93px;
    }
}

.recharge_btn {
    display: block;
    color: #fff;
    font-size: 30px;
    text-align: center;
    line-height: 80px;
    height: 80px;
    background: #0346D5;
    border-radius: 50px;
    margin-top: 32px;
}
</style>